import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { TabsProvider } from './Tabs.Context/Tabs.Context.es.js';
import { TabsItem } from './Tabs.Item/Tabs.Item.es.js';

const Tabs = ({ children, current, variant = 'primary' })=>{
    const [theme, name] = variant.split('/');
    return jsx(TabsProvider, {
        current: current,
        variant: variant,
        children: jsx("ul", {
            className: classNames('cb-tabs', theme, name),
            children: children
        })
    });
};
Tabs.displayName = 'Tabs';
Tabs.Item = TabsItem;

export { Tabs, Tabs as default };
//# sourceMappingURL=Tabs.es.js.map
